<template>
  <button
    class="upgrade-banner"
    @click="handleOnBannerClick"
  >
    <UpgradeIcon/>
    <span class="colorful-text">Upgrade to unlock</span>
  </button>
</template>

<script>
import UpgradeIcon from '@/assets/icons/optimized/upgrade_mobile.svg?inline';

export default {
  name: 'TUpgradeBannerSmall',
  components: {
    UpgradeIcon,
  },
  methods: {
    handleOnBannerClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/mixins";

$padding-size: 8px;

.upgrade-banner {
  box-sizing: border-box;
  padding: $padding-size;
  background-color: #f4f2fe;
  border: 1px solid #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: 3px;
  height: 40px;
  flex-direction: row;
  width: 100%;
  cursor: pointer;
}

.colorful-text {
  font-size: 15px;
  line-height: 24px;
  background: linear-gradient(45deg, #0507FF 0%, #AF15B1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-color: #0507FF;
  background-clip: text;
  text-fill-color: transparent;
}
</style>
